import { createContext, MutableRefObject } from 'react';

/**
 * Actions that can be taken from within the modal via instance context
 */
export interface LuiModalAsyncInstanceContextType {
  ownerRef: MutableRefObject<HTMLElement | null>;
  close: () => void;
  // eslint-disable-next-line
  resolve: (value: any) => void;
}

const NoContextError = () => {
  console.error('Missing LuiModalAsyncInstanceContext Provider');
};

/**
 * Provides access to resolving/closing to modal elements.
 */
export const LuiModalAsyncInstanceContext = createContext<LuiModalAsyncInstanceContextType>({
  ownerRef: { current: null },
  close: NoContextError,
  resolve: NoContextError,
});
